<template>
    <div>
        <b-row>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                <b-card class="sa-card sa-card-border" header="Anamnesi Sociale" header-tag="header" footer-tag="footer" title="">
                    <b-row>
                        <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
                            <span v-if="isReadOnly">{{ jsonDataAnamnesiSociale.voce }}</span>
                            <b-form-textarea v-else v-model="jsonDataAnamnesiSociale.voce" :readonly="isReadOnly" max-rows="10" rows="8"> </b-form-textarea>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
import UtilityMixin from "../../../utility/UtilityMixin";

export default {
    props: {
        isReadOnly: {
            type: Boolean,
            default: false,
        },
        idAccettazione: {
            type: String,
        },
        jsonDataAnamnesiSociale: {
            type: Object,
            default: function () {
                return {
                    id: null,
                    idAccettazione: this.idAccettazione,
                    voce: "",
                };
            },
        },
    },
    mixins: [UtilityMixin],
    watch: {
        jsonDataAnamnesiSociale: {
            handler(jsonData) {
                this.$emit("update", jsonData);
            },
            deep: true,
        },
    },
    data() {
        return {
            pathResourceSchedaRelazioneSanitariaAnamnesiSociale: "/rsaschedarelazionesanitariaanamnesisociale",
        };
    },
    methods: {
        loadSchedaRelazioneSanitariaAnamnesiSociale() {
            let me = this;
            UtilityMixin.methods.loadDataResources(me.pathResourceSchedaRelazioneSanitariaAnamnesiSociale + "/accettazione/" + me.idAccettazione, {}, me.resultResponseSchedaRelazioneSanitariaAnamnesiSocialeSuccess, me.resultResponseSchedaRelazioneSanitariaAnamnesiSocialeError);
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiSocialeSuccess(response) {
            let me = this;
            me.jsonDataAnamnesiSociale = response.data.data;
        },

        resultResponseSchedaRelazioneSanitariaAnamnesiSocialeError(error) {
            let me = this;
            if (error.response && error.response.status === 404) {
                me.resetForm();
            }
        },

        resetForm() {
            let me = this;
            me.jsonDataAnamnesiSociale = {
                id: null,
                idAccettazione: me.idAccettazione,
                voce: null,
            };
        },

        onAnamnesiSociale() {
            let me = this;
            me.jsonDataAnamnesiSociale.idAccettazione = me.idAccettazione;
            if (!me.jsonDataAnamnesiSociale.idAccettazione) {
                me.$bvToast.toast("Errore: ID Accettazione mancante", {
                    title: "Errore",
                    variant: "danger",
                    solid: true,
                });
                return;
            }
            UtilityMixin.methods.saveResource(me.pathResourceSchedaRelazioneSanitariaAnamnesiSociale, me.jsonDataAnamnesiSociale, me.saveSchedaRelazioneSanitariaAnamnesiSocialeSuccessResponse, me.saveSchedaRelazioneSanitariaAnamnesiSocialeErrorResponse);
        },
        saveSchedaRelazioneSanitariaAnamnesiSocialeSuccessResponse() {},
        saveSchedaRelazioneSanitariaAnamnesiSocialeErrorResponse() {
            console.error("Errore nel salvataggio anamnesi sociale:");
        },
    },
};
</script>
